import React, { useEffect, useState } from 'react';
import { useEHRContext } from 'contexts/EHRContext';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from '@material-ui/lab';
import { fixTimezoneOffset, monthNames } from 'utils/dateFunctions';
import { currentMode, endpoints, features } from 'configs';
import '../TemplateTab/TemplateTab.css';
import { formatName, logDebug, retrieveData } from 'utils/AuxiliarFunctions';
import xdsToken from 'services/xdsToken';
import axios from 'axios';
import { ToastMessage } from 'components';
import { toast } from 'react-toastify';
import { DocumentsCard } from '../DocumentsCard';
import { DocumentsVisualizer } from '../DocumentsVisualizer';
import { EmptyFieldWarning } from '../EmptyFieldWarning';
import { LoadMoreButton } from '../LoadMoreButton';

export function DocumentsTimeline({ page = false }) {
  const { prescription, eventSummary, certificates } = useEHRContext();
  const { ehrState } = useEHRContext();

  const [modalContent, setModalContent] = useState({});
  const [filter, setFilter] = useState('Atestados');
  const [loadingMoreDocuments, setLoadingMoreDocuments] = useState(false);

  const [timeLineCertificates, setTimelineCertificates] = useState([]);
  const [certificatesNextUrl, setCertificatesNextUrl] = useState('');

  const [timelinePrescriptions, setTimelinePrescriptions] = useState([]);
  const [prescriptionsNextUrl, setPrescriptionsNextUrl] = useState('');

  const [timelineEventSummary, setTimelineEventSummary] = useState([]);
  const [eventSummaryNextUrl, setEventSummaryNextUrl] = useState('');

  function selectTimeline() {
    if (filter === 'Prescrições') return timelinePrescriptions;
    if (filter === 'Outros') return timelineEventSummary;
    return timeLineCertificates;
  }

  const displayTimeline = selectTimeline();
  const dateCards = [];
  displayTimeline.forEach((element) => {
    const isoDate =
      element?.resource.context?.period?.start ||
      element?.resource.context?.period?.end ||
      '';
    const month =
      monthNames[fixTimezoneOffset(new Date(isoDate)).getMonth() + 1];
    const year = fixTimezoneOffset(new Date(isoDate)).getFullYear();
    if (!dateCards.includes(`${month} - ${year}`))
      dateCards.push(`${month} - ${year}`);
    else dateCards.push('');
  });

  const [selectedIndex, setSelectedIndex] = useState(1);

  async function getTokens() {
    await xdsToken.getBearerToken();
    const bearerToken = await retrieveData('application_token');
    const xUserToken = await retrieveData('token');
    return { bearerToken, xUserToken };
  }

  function handleUpdateCertificates() {
    try {
      if (certificatesNextUrl) {
        const link = `${endpoints.MHD}?${certificatesNextUrl.split('?')[1]}`;

        getTokens().then((tokens) => {
          const headers = {
            authorization: `Bearer ${
              ehrState.subject.token || tokens.bearerToken
            }`,
            'x-user-Token': `${ehrState.subject.token || tokens.xUserToken}`,
            'Content-Type': 'application/fhir+json',
            Accept: 'application/fhir+json',
            purposeofuse: 'Atendimento',
            ...(ehrState.subject.organizationId && {
              'organization-id': ehrState.subject.organizationId,
            }),
            ...(ehrState.resource.id &&
              currentMode === 'aghu' && {
                'resource-id': ehrState.resource.id,
              }),
            ...(ehrState.subject.id && { 'subject-id': ehrState.subject.id }),
          };
          axios({
            method: 'get',
            url: link,
            headers,
            timeout: 5000,
          })
            .then(async ({ data: response }) => {
              toast.success(
                <ToastMessage type="success">
                  {' '}
                  Requisição completada.
                </ToastMessage>,
              );
              setTimelineCertificates([
                ...timeLineCertificates,
                ...response.entry,
              ]);
              setCertificatesNextUrl(
                response.link.find(({ relation }) => relation === 'next')?.url,
              );
            })
            .catch((err) => {
              try {
                logDebug(err);
                toast.error(
                  <ToastMessage type="error">
                    {' '}
                    Requisição completada.
                  </ToastMessage>,
                );
              } catch {
                // toast de error
              }
            })
            .then(() => {
              setLoadingMoreDocuments(false);
            });
        });
      }
    } catch (err) {
      logDebug(err);
    }
  }

  function handleUpdatePrescriptions() {
    try {
      if (prescriptionsNextUrl) {
        const link = `${endpoints.MHD}?${prescriptionsNextUrl.split('?')[1]}`;

        getTokens().then((tokens) => {
          const headers = {
            authorization: `Bearer ${
              ehrState.subject.token || tokens.bearerToken
            }`,
            'x-user-Token': `${ehrState.subject.token || tokens.xUserToken}`,
            'Content-Type': 'application/fhir+json',
            Accept: 'application/fhir+json',
            purposeofuse: 'Atendimento',
            ...(ehrState.subject.organizationId && {
              'organization-id': ehrState.subject.organizationId,
            }),
            ...(ehrState.resource.id &&
              currentMode === 'aghu' && {
                'resource-id': ehrState.resource.id,
              }),
            ...(ehrState.subject.id && { 'subject-id': ehrState.subject.id }),
          };
          axios({
            method: 'get',
            url: link,
            headers,
            timeout: 5000,
          })
            .then(async ({ data: response }) => {
              toast.success(
                <ToastMessage type="success">
                  {' '}
                  Requisição completada.
                </ToastMessage>,
              );
              setTimelinePrescriptions([
                ...timelinePrescriptions,
                ...response.entry,
              ]);
              setPrescriptionsNextUrl(
                response.link.find(({ relation }) => relation === 'next')?.url,
              );
            })
            .catch((err) => {
              try {
                logDebug(err);
                toast.error(
                  <ToastMessage type="error">
                    {' '}
                    Requisição completada.
                  </ToastMessage>,
                );
              } catch {
                // toast de error
              }
            })
            .then(() => {
              setLoadingMoreDocuments(false);
            });
        });
      }
    } catch (err) {
      logDebug(err);
    }
  }

  function handleUpdateEventSummary() {
    try {
      if (eventSummaryNextUrl) {
        const link = `${endpoints.MHD}?${eventSummaryNextUrl.split('?')[1]}`;

        getTokens().then((tokens) => {
          const headers = {
            authorization: `Bearer ${
              ehrState.subject.token || tokens.bearerToken
            }`,
            'x-user-Token': `${ehrState.subject.token || tokens.xUserToken}`,
            'Content-Type': 'application/fhir+json',
            Accept: 'application/fhir+json',
            purposeofuse: 'Atendimento',
            ...(ehrState.subject.organizationId && {
              'organization-id': ehrState.subject.organizationId,
            }),
            ...(ehrState.resource.id &&
              currentMode === 'aghu' && {
                'resource-id': ehrState.resource.id,
              }),
            ...(ehrState.subject.id && { 'subject-id': ehrState.subject.id }),
          };
          axios({
            method: 'get',
            url: link,
            headers,
            timeout: 5000,
          })
            .then(async ({ data: response }) => {
              toast.success(
                <ToastMessage type="success">
                  {' '}
                  Requisição completada.
                </ToastMessage>,
              );
              setTimelineEventSummary([
                ...timelineEventSummary,
                ...response.entry,
              ]);
              setEventSummaryNextUrl(
                response.link.find(({ relation }) => relation === 'next')?.url,
              );
            })
            .catch((err) => {
              try {
                logDebug(err);
                toast.error(
                  <ToastMessage type="error">
                    {' '}
                    Requisição completada.
                  </ToastMessage>,
                );
              } catch {
                // toast de error
              }
            })
            .then(() => {
              setLoadingMoreDocuments(false);
            });
        });
      }
    } catch (err) {
      logDebug(err);
    }
  }

  useEffect(() => {
    if (Array.isArray(certificates?.link)) {
      setCertificatesNextUrl(
        certificates?.link.length > 1
          ? certificates?.link.find(({ relation }) => relation === 'next').url
          : '',
      );
    }
    if (Array.isArray(certificates?.entry))
      setTimelineCertificates(certificates?.entry);
  }, [certificates]);

  useEffect(() => {
    if (Array.isArray(prescription?.link)) {
      setPrescriptionsNextUrl(
        prescription?.link.length > 1
          ? prescription?.link.find(({ relation }) => relation === 'next').url
          : '',
      );
    }
    if (Array.isArray(prescription?.entry))
      setTimelinePrescriptions(prescription?.entry);
  }, [prescription]);

  useEffect(() => {
    if (Array.isArray(eventSummary?.link)) {
      setEventSummaryNextUrl(
        eventSummary?.link.length > 1
          ? eventSummary?.link.find(({ relation }) => relation === 'next').url
          : '',
      );
    }
    if (Array.isArray(eventSummary?.entry))
      setTimelineEventSummary(eventSummary?.entry);
  }, [eventSummary]);

  return (
    <>
      <div className={page ? 'EHRArea-tabs' : 'EHRfilterButtons'}>
        <button
          className={
            filter === 'Atestados' &&
            (page ? 'EHRArea-openTab' : 'EHRfilterButtons-selected')
          }
          onClick={() => {
            setFilter('Atestados');
          }}
        >
          Atestados
        </button>
        <button
          className={
            filter === 'Prescrições' &&
            (page ? 'EHRArea-openTab' : 'EHRfilterButtons-selected')
          }
          onClick={() => {
            setFilter('Prescrições');
          }}
        >
          Prescrições
        </button>
        {!features.myReports && (
          <button
            className={
              filter === 'Outros' &&
              (page ? 'EHRArea-openTab' : 'EHRfilterButtons-selected')
            }
            onClick={() => setFilter('Outros')}
          >
            Outros
          </button>
        )}
      </div>

      {displayTimeline.length ? (
        <div className="documentsTab-containter">
          <div className="ehrTimeline-container">
            <Timeline>
              {displayTimeline.map((element, index) => {
                const auxDate =
                  element.resource?.context?.period?.start ||
                  element?.resource.context?.period?.end ||
                  '';
                const auxType = element.resource?.type.coding[0].display || '';
                const auxPractitioner = element.resource?.contained?.find(
                  (identifier) => identifier.resourceType === 'Practitioner',
                );
                let auxPractitionerName =
                  auxPractitioner?.name[0].text ||
                  auxPractitioner?.name?.find(({ given }) => given)?.given ||
                  'Indisponível';
                if (Array.isArray(auxPractitionerName))
                  auxPractitionerName = auxPractitionerName[0];

                const auxOrganization = element.resource?.contained?.find(
                  (identifier) => identifier.resourceType === 'Organization',
                );
                // const auxOrganizationId = auxOrganization.identifier[0].value;
                // const auxOrganizationAlias = auxOrganization.alias ? auxOrganization.alias[0] : auxOrganization.name || 'Não Encontrado';
                // const auxOrganizationName = auxOrganization && auxOrganization.name;
                const auxDocumentBinaryId =
                  element.resource?.content[0].attachment?.url;
                const contentType = element.resource?.content[0]?.format?.code;
                return (
                  <>
                    {dateCards[index] && (
                      <TimelineItem
                        key={`timelineDateItemCard-${dateCards[index]}`}
                      >
                        <TimelineSeparator>
                          <TimelineDot className="highlight" />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                          <div className="ehrTimeline-dateCard">
                            {dateCards[index]}
                          </div>
                        </TimelineContent>
                      </TimelineItem>
                    )}
                    <TimelineItem
                      key={`timelineItemCard-${element.resource.id}`}
                    >
                      <TimelineSeparator>
                        <TimelineDot />
                        {index !== displayTimeline.length - 1 && (
                          <TimelineConnector />
                        )}
                      </TimelineSeparator>
                      <TimelineContent>
                        <DocumentsCard
                          selectedIndex={selectedIndex}
                          index={index}
                          setSelectedIndex={setSelectedIndex}
                          setModalContent={setModalContent}
                          documentBinaryId={auxDocumentBinaryId}
                          date={auxDate || ''}
                          type={auxType}
                          contentType={contentType}
                          organizationName={auxOrganization}
                          binary={auxDocumentBinaryId}
                          description={`Profissional: ${formatName(
                            auxPractitionerName,
                          )}`}
                          alias={
                            auxOrganization?.alias[0] ||
                            auxOrganization?.name ||
                            ''
                          }
                        />
                      </TimelineContent>
                    </TimelineItem>
                  </>
                );
              })}
            </Timeline>

            {certificatesNextUrl && filter === 'Atestados' && (
              <LoadMoreButton onClick={handleUpdateCertificates} />
            )}
            {prescriptionsNextUrl && filter === 'Prescrições' && (
              <LoadMoreButton onClick={handleUpdatePrescriptions} />
            )}
            {eventSummaryNextUrl && filter === 'Outros' && (
              <LoadMoreButton onClick={handleUpdateEventSummary} />
            )}
          </div>
          {modalContent.link && (
            <DocumentsVisualizer modalContent={modalContent} />
          )}
        </div>
      ) : (
        <EmptyFieldWarning />
      )}
    </>
  );
}
